const getRestrictions = async () => {
    try {
        const url = window.location.href;
        const isLocalhost = url.includes('localhost');
        const isSafeSakay = url.includes('safesakay.bpimsapps.com');
        const isSafeSakayBpi = url.includes('safesakay.bpims.com');
        const [, stage, , flag] = url.split('.');

        const endpoint = isLocalhost
            ? "https://partners-api.dev.bpimsapps.com/policy/restrictions"
            : isSafeSakay
                ? "https://partners-api.uat.bpimsapps.com/policy/restrictions"
                : isSafeSakayBpi
                    ? `${flag ? 'https://partners-api' : 'https://fes'}.${flag ? `${stage}.` : ''}bpimsapps.com${flag ? '' : '/partners'}/policy/restrictions`
                    : `${flag ? 'https://partners-api' : 'https://fes'}.${flag ? `${stage}.` : ''}bpimsapps.com${flag ? '' : '/partners'}/policy/restrictions`;

        const response = await fetch(endpoint, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                params: 'PA365'
            })
        });

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();
        return data.data;
    } catch (error) {
        console.error('getRestrictions api error', error);
        throw error;
    }
};

export default getRestrictions;
